import React from "react";
import { Table, TableCell, TableRow, Typography } from "@mui/material";
import { Container } from "./styles";
import theme from "../../../../Styles/theme";

interface Props {
  total: number;
  transmitida: number;
  frente: number;
  fundo: number;
  direita: number;
  esquerda: number;
}

export function DimensoesSection({
  total,
  frente,
  fundo,
  direita,
  esquerda,
  transmitida,
}: Props) {
  return (
    <Container>
      <Table
        size="small"
        style={{
          border: "1px solid rgba(224, 224, 224, 1)",
          background: theme.colors.light,
          borderRadius: "0.25rem",
          padding: "0px",
          color:"black"
        }}
      >
        <TableRow>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
          >
            Área Total
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
          >
            Área Transmitida
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
          >
            Frente
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
          >
            Fundo
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
          >
            Direita
          </TableCell>
          <TableCell
            style={{
              textAlign: "center",
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
          >
            Esquerda
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            style={{
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
            align={"center"}
          >
            {total
              ? total.toLocaleString("pt-BR", { minimumFractionDigits: 6 })
              : "0"}
            m²
          </TableCell>
          <TableCell
            style={{
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
            align={"center"}
          >
            {transmitida
              ? transmitida.toLocaleString("pt-BR", {
                  minimumFractionDigits: 6,
                })
              : "0"}
            m²
          </TableCell>
          <TableCell
            style={{
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
            align={"center"}
          >
            {frente
              ? frente.toLocaleString("pt-BR", { minimumFractionDigits: 6 })
              : "0"}
            m
          </TableCell>
          <TableCell
            style={{
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
            align={"center"}
          >
            {fundo
              ? fundo.toLocaleString("pt-BR", { minimumFractionDigits: 6 })
              : "0"}
            m
          </TableCell>
          <TableCell
            style={{
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
            align={"center"}
          >
            {direita
              ? direita.toLocaleString("pt-BR", { minimumFractionDigits: 6 })
              : "0"}
            m
          </TableCell>
          <TableCell
            style={{
              border: "1px solid rgba(224, 224, 224, 1)",
              padding: "0px",
              color:"black"
            }}
            align={"center"}
          >
            {esquerda
              ? esquerda.toLocaleString("pt-BR", { minimumFractionDigits: 6 }).replace("R$","")
              : "0"}
            m
          </TableCell>
        </TableRow>
      </Table>
    </Container>
  );
}
